import React, { useEffect, useState } from "react";
import {
 fetchAllSocialMedia,
 createSocialMedia,
 updateSocialMedia,
 deleteSocialMedia,
} from "./adminSocialMediaService";
import "./socialMedia.css";

const SOCIAL_MEDIA_TYPES = [
 "WHATSAPP_MOBILE",
 "WHATSAPP_CHANNEL",
 "WHATSAPP_GROUP",
 "FACEBOOK",
 "INSTAGRAM",
 "LINKEDIN",
 "YOUTUBE",
 "MOBILE_APP",
 "WEBSITE",
];

const emptyForm = { type: "WHATSAPP_MOBILE", name: "", link: "" };

const AdminSocialMediaPage = () => {
 const [entries, setEntries] = useState([]);
 const [form, setForm] = useState(emptyForm);
 const [editing, setEditing] = useState(null);
 const [showForm, setShowForm] = useState(false);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadEntries();
 }, []);

 const loadEntries = async () => {
 setLoading(true);
 const res = await fetchAllSocialMedia();
 if (res.status === 200) setEntries(res.data);
 else alert(res.message || "Failed to load");
 setLoading(false);
 };

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSave = async () => {
 if (!form.name.trim() || !form.link.trim()) {
 alert("Name and Link are required");
 return;
 }
 setLoading(true);
 const res = editing
 ? await updateSocialMedia(editing.id, form)
 : await createSocialMedia(form);

 if (res.status === 200 || res.status === 201) {
 setShowForm(false);
 setEditing(null);
 setForm(emptyForm);
 loadEntries();
 } else {
 alert(res.message || "Save failed");
 }
 setLoading(false);
 };

 const handleEdit = (entry) => {
 setEditing(entry);
 setForm({ type: entry.type, name: entry.name, link: entry.link });
 setShowForm(true);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Are you sure you want to delete this entry?")) return;
 const res = await deleteSocialMedia(id);
 if (res.status === 200 || res.status === 204) loadEntries();
 else alert(res.message || "Delete failed");
 };

 const handleCancel = () => {
 setShowForm(false);
 setEditing(null);
 setForm(emptyForm);
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Social Media Details</h2>
 <button onClick={() => { setEditing(null); setForm(emptyForm); setShowForm(true); }}>
 + Add Entry
 </button>
 </div>

 {showForm && (
 <div className="form-card">
 <h3>{editing ? "Edit Entry" : "Add New Entry"}</h3>
 <div className="sm-form-grid">
 <div className="form-group">
 <label>Type</label>
 <select name="type" value={form.type} onChange={handleChange}>
 {SOCIAL_MEDIA_TYPES.map((t) => (
 <option key={t} value={t}>{t.replace(/_/g, " ")}</option>
 ))}
 </select>
 </div>
 <div className="form-group">
 <label>Name</label>
 <input name="name" value={form.name} onChange={handleChange} placeholder="Display name" />
 </div>
 <div className="form-group">
 <label>Link / Number</label>
 <input name="link" value={form.link} onChange={handleChange} placeholder="URL or phone number" />
 </div>
 </div>
 <div className="form-actions">
 <button className="btn primary" onClick={handleSave} disabled={loading}>
 {loading ? "Saving..." : "Save"}
 </button>
 <button className="btn secondary" onClick={handleCancel}>Cancel</button>
 </div>
 </div>
 )}

 {loading && !showForm ? (
 <p>Loading...</p>
 ) : (
 <table className="sm-table">
 <thead>
 <tr>
 <th>Type</th>
 <th>Name</th>
 <th>Link</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {entries.length === 0 ? (
 <tr><td colSpan="4">No entries found</td></tr>
 ) : (
 entries.map((e) => (
 <tr key={e.id}>
 <td>{e.type.replace(/_/g, " ")}</td>
 <td>{e.name}</td>
 <td className="link-cell">{e.link}</td>
 <td>
 <button onClick={() => handleEdit(e)}>Edit</button>
 <button className="delete-btn" onClick={() => handleDelete(e.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}
 </div>
 );
};

export default AdminSocialMediaPage;
